import { Http, Headers } from '@angular/http';
import { Injectable } from '@angular/core';
import { ApiBaseService } from './api-base.service';
import { StateService } from './../state.service';
import { AlertService } from '../alert.service';
import { ToastService } from '../toast.service';
import { App, Events, Platform, LoadingController, ToastController } from "ionic-angular";
import { ApiAuthStore } from '../store/api.auth.store';
import { UtilService } from '../util.service';

@Injectable()
export class ApiPatientVitalgrafService extends ApiBaseService {

  protected headers: Headers;
  isLoading: boolean = true;

  constructor(
    protected app: App,
    protected events: Events,
    protected http: Http,
    public plt: Platform,
    protected stateService: StateService,
    protected alertService: AlertService,
    protected toastService: ToastService,
    protected loadingCtrl: LoadingController,
    protected toastController: ToastController,
    protected apiAuthStore: ApiAuthStore,
    public utilService: UtilService,
  ) {
    super(app, events, http, plt, stateService, alertService, toastService, loadingCtrl, toastController, apiAuthStore, utilService);
  }

  /**
   *
   * @return void
   */
  get(patientId:string, params:any = {}): Promise<any> {
    // TODO: GETの場合はBODYではなく、QueryStringに付与してAPIを実行する
    let url = this.apiAuthStore.url + '/api/v1/patient/' + patientId + '/vitalgraf';
    url += '?';
    if (params) {
      Object.keys(params).forEach(key => {
        url += `${key}=${params[key]}`;
     });
    }

    this.isLoading = true
    return new Promise((resolve) => {
      return this.doGet({
        url: url,
        body: {}, headers: this.headers}
      ).finally(
        () => this.isLoading = false
      ).subscribe(
        response => resolve(response)
      )
    })

  }

  /**
   * patientId、期間の前後端（タイムスタンプ）、vitalTypeの指定でバイタルデータを時系列順に取得する
   * @return void
   */
  getByTypesBetween(params: {
    patientId: string,
    start: number,
    end: number,
    types: string[],
  }): Promise<any> {
    this.isLoading = true;
    return new Promise((resolve) => {
      const url = this.apiAuthStore.url + `/api/v1/vitals/${params.patientId}?start=${params.start}&end=${params.end}&types=${params.types.join(',')}`
      return this.doGet({
        url: url,
        body: {},
        headers: this.headers
      }).finally(
        () => this.isLoading = false
      ).subscribe(
        response => resolve(response)
      )
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/api-call-providers/api-patient-vitalgraf.service.ts